export default __webpack_public_path__ + "static/media/fine.247174b7.gif";